{
  "test": "Тестовое сообщение",
  "email_subscribe_header": "Узнай первым",
  "email": "Электронная почта",
  "password": "Пароль",
  "recovery": "Восстановление пароля",
  "recovery_subtitle": "Код подтверждения отправлен на",
  "recovery_code": "Введите код",
  "forgot_pass": "Забыли пароль?",
  "pass": "Введите ваш пароль",
  "pass_subtitle": "Вы включили двухэтапную аутентификацию. ",
  "your_email": "Ваш адрес электронной почты",
  "your_password": "Ваш пароль",
  "subscribe": "Подписаться",
  "rights": "© 2024 CardBook. All rights reserved.",
  "terms": "Условия",
  "privacy": "Политика",
  "quick_links": "Быстрые ссылки",
  "news": "Новости",
  "packages": "Пакеты",
  "about_us": "О нас",
  "how_it_works": "Как это работает",
  "main_functions": "Основные функции",
  "contacts": "Контакты",
  "sign_in": "Войти",
  "create_account": "Завести аккаунт",
  "next": "Дальше",
  "back": "Назад",
  "confirm": "Подтвердить",
  "send": "Отправить",
  "resend_code": "Отправить код Снова",
  "resend": "Отправить код",
  "invalid_code": "Неверный код",
  "terms_accept_checkbox": "Я прочитал(а) и принимаю Условия и положения и Политику конфиденциальности",
  "terms_accept_required": "Примите Условия и положения и Политику конфиденциальности, чтобы продолжить",
  "terms_updated_title": "Наши Условия и Политика конфиденциальности обновлены",
  "terms_updated_body": "Ознакомьтесь с обновлёнными документами и примите их, чтобы продолжить пользоваться CardBook.",
  "terms_updated_on": "Последнее обновление: {date}",
  "terms_accept_button": "Принять и продолжить",
  "country": "Страна",
  "sign_in_to": "Войдите в CardBook",
  "sign_up_to": "Зарегистрируйтесь в CardBook",
  "keep_me_signed_in": "Оставить меня в системе",
  "sign_in_subtitle": "Чтобы войти, пожалуйста, подтвердите свою страну и введите свой номер телефона.",
  "email_sign_in_subtitle": "Чтобы войти, введите свой email или продолжите с номером телефона",
  "sign_in_by_email": "Войти по электронной почте",
  "sign_in_by_phone": "Войти по номеру телефона",
  "pin_subtitle": "Мы отправили код на подтвержденный телефон.",
  "pin_email_subtitle": "Мы отправили код на указанный email",
  "didnt_receive_code": "Не пришел код?",
  "sign_in_with_email": "Войти через email",
  "no_code_hint": "Код может не прийти из-за ограничений оператора или страны. Мы работаем над решением и скоро устраним эту проблему",
  "set_new_password": "Установить новый пароль",
  "set_new_password_subtitle": "Пожалуйста, создайте новый пароль для вашей учетной записи",
  "link_email": "Привязать email",
  "link_email_subtitle": "Это необходимо для сброса пароля, активации и входа в аккаунт.",
  "registration_subtitle": "Мы заметили, что вы с нами впервые! ",
  "reg_agreement": "Регистрируясь, вы соглашаетесь с <a style='color: #4497B0; text-decoration: underline;' href='{terms}' target='_blank' rel='noopener'>Условия и положения</a> и <a style='color: #4497B0; text-decoration: underline;' href='{privacy}' target='_blank' rel='noopener'>политика конфиденциальности</a>, в том числе <a style='color: #4497B0; text-decoration: underline;' href='{cookie}' target='_blank' rel='noopener'>Политика использования файлов cookie</a>.",
  "first_name": "Имя",
  "last_name": "Фамилия",
  "my_profile": "Мой профиль",
  "my_cabinet": "Мой кабинет",
  "settings": "Настройки",
  "log_out": "Выйти из профиля",
  "overview": "Главная",
  "search": "Поиск",
  "digital_bank": "Digital Bank",
  "chat": "Чат",
  "connector": "Connector",
  "info_hub": "InfoHub",
  "subscriptions": "Подписки",
  "support": "Поддержка",
  "help": "Помощь",
  "terms_tool": "Условия",
  "privacy_tool": "Конфиденциальность",
  "more": "Еще",
  "log_out_": "Выйти",
  "begin": "Начинать",
  "phone": "Мобильный номер",
  "curr_detail": "Введите свои текущие данные. Добавьте фотографию и заполните актуальную информацию. Это важный пункт, благодаря которому любой пользователь, зайдя в ваш профиль, сможет узнать вас и понять, чем вы занимаетесь.",
  "edit_profile_text": "Теперь ваш профиль заполнен. Наличие фотографии в профиле очень важно, так как она помогает пользователям понять, кто вы и чем занимаетесь. Постоянно обновляйте информацию, чтобы получать лучшие результаты от нетворкинга.",
  "find_friend": "Найдите своих друзей на платформе или загрузите их визитные карточки и сохраните в Digital Bank. Мы рекомендуем сразу отсортировать их и указать уровень доступа к контакту. (Подробнее об уровнях доступа в CardBook можно узнать",
  "find_friend_link": "здесь)",
  "search_section": "Посетите раздел «Поиск» — именно здесь будет отображаться ваша визитная карточка после заполнения профиля. Это бесконечная лента ценных контактов и людей, с которыми вы можете связаться на CardBook.",
  "might_be": "Может быть полезно",
  "useful_video": "Полезное видео",
  "fresh_events": "Свежие события",
  "validation_required": "Поле, обязательное для заполнения.",
  "validation_email": "Введите действующий адрес электронной почты.",
  "validation_url": "Введите действительный URL-адрес",
  "validation_password": "Пароль должен содержать минимум восемь символов, как минимум одну цифру, одну заглавную и одну строчную букву.",
  "validation_password_confirm": "Пароли должны совпадать.",
  "validation_min": "{field} должен быть не менее {n} символов.",
  "validation_max": "Максимально допустимая длина {field} — {n}.",
  "validation_birth": "Введите правильную дату.",
  "validation_phone": "Введите действительный номер телефона.",
   "validation_min_phone": "Телефон должен быть не менее 10 символов.",
  "validation_max_phone": "Максимально допустимая длина телефона 14.",
  "error": "Ошибка",
  "mail_exist": "Этот адрес электронной почты уже использовался",
  "error_login": "Неправильный телефон.",
  "error_pass": "Неправильный пароль.",
  "error_pin": "Неправильный пин-код.",
  "error_registration": "Ошибка регистрации.",
  "error_update_user": "Ошибка обновления данных пользователя.",
  "error_server": "Ошибка сервера.",
  "error_occurred": "Произошла ошибка.",
  "translation_failed": "Не удалось перевести. Показан исходный текст.",
  "error_update_image": "Ошибка загрузки изображения.",
  "complete_profile": "Заполните свой профиль",
  "add_card": "Добавить визитку",
  "expand": "Расширяйте сеть контактов",
  "btn_fill": "Заполнить профиль",
  "visit_secret": "Посетите поиск",
  "welcome": "Добро пожаловать!",
  "welcome_banner": "Добро пожаловать",
  "joined": "Вы присоединились к CardBook",
  "text_modal": "CardBook — это платформа, где у вас есть безграничные возможности! ",
  "edit": "Редактировать профиль",
  "processing": "Обработка..",
  "not_found": "Страница не найдена",
  "not_found_text": "Извините, но мы не смогли найти запрошенную страницу. ",
  "home": "Дом",
  "cardMarket": "CardMarket",
  "remaining": "Оставшийся",
  "add_new_contact": "Добавить новый контакт",
  "name": "Имя",
  "surname": "Фамилия",
  "competence": "Компетентность",
  "profile_miss": "В профиле отсутствует информация",
  "attention_modal": "Если вы хотите добавить контент, вы должны заполнить все данные в своем личном профиле.",
  "later": "Позже",
  "fill_btn": "Заполнить профиль",
  "no_email": "Электронная почта не связана",
  "no_email_text": "Если вы хотите добавить контент, вам необходимо связать свой адрес электронной почты.",
  "add_email": "Добавить электронную почту",
  "add": "Добавить",
  "no_matches": "На платформе не найдено совпадений по указанным данным.",
  "add_text": "Если нужного человека нет в списке",
  "positioning": "Род деятельности",
  "city": "Город",
  "direction": "Направления",
  "talk_language": "Язык общения",
  "price_for_access": "Цена за доступ",
  "write_text": "Напишите текст подсказки",
  "Newbie": "Новичок",
  "Skilled": "Опытный",
  "Expert": "Эксперт",
  "edit_cover": "Редактировать фото",
  "edit_profile": "Редактировать профиль",
  "remove_cover": "Удалить фото",
  "select_cover": "Обновить фото",
  "about_me": "Обо мне",
  "industries": "Индустрии",
  "directions": "Направления",
  "competences": "Компетенции",
  "expertise": "Уровень опыта",
  "languages": "Язык общения",
  "load_more": "Загрузить больше",
  "save": "Сохранить",
  "delete_this_contact": "Удалить этот контакт",
  "add_to_bank": "Добавить в DigitalBank",
  "socials": "Социальные сети",
  "subscribers": "Подписчики",
  "get_data": "Ошибка загрузки данных",
  "get_access": "Получить доступ",
  "familiar": "Если вы знакомы с этим контактом",
  "text_add": "Вы можете добавить его в свой цифровой банк для хранения. ",
  "level_access": "Уровень доступа",
  "add_contact_bank": "Вы успешно добавили контакт",
  "filter": "Фильтр",
  "reset_filters": "Сбросить все фильтры",
  "apply": "Применять",
  "expertise_level": "Уровень опыта",
  "new_contact": "Вы добавляете новый контакт",
  "in_bank": "В вашем Digital Bank",
  "search_title": "Поиск по CardBook",
  "search_notif": "Это виртуальный каталог с бесконечной лентой визитных карточек. Чтобы оказаться среди них, заполните свой профиль.",
  "tags": "Теги",
  "profile_info": "О профиле",
  "profile_preview": "Предварительный просмотр профиля",
  "your_profile_must_be_completed": "Чтобы появиться в общем поиске, ваш профиль должен быть заполнен.",
  "basic_information": "Основная информация",
  "basic_information_text": "Укажите свои личные данные, чтобы вас было проще найти и вызвать больше доверия в общении.",
  "basic_information_positioning": "Кем вы себя позиционируете?",
  "basic_information_positioning_placeholder": "макс. 30 символов ",
  "avatar_cover_title": "Аватар и обложка",
  "avatar_cover_text": "Замените образы системы на свои. ",
  "upload_new_cover": "Загрузите",
  "location": "Местоположение",
  "location_text": "Добавьте информацию о своем основном местонахождении. Потенциальные клиенты смогут найти вас по соответствующим фильтрам.",
  "additional_information": "Дополнительная информация",
  "additional_information_text": "Дополнительная информация сильно влияет на доверие во взаимодействии между пользователями. ",
  "interest_needs": "Интересы и потребности",
  "interest_needs_text": "Повысьте ценность своего профиля в сети, рассказав о своих текущих потребностях и интересах.",
  "save_profile": "Сохранить профиль",
  "show": "Показывать",
  "clear": "Очистить",
  "potential_income": "Ваш потенциальный доход от контактов вашего CardMarket",
  "calculate": "Рассчитать",
  "networking": "Калькулятор дохода от нетворкинга",
  "text_calculator": "Здравствуйте! Мы создали этот калькулятор для удобства расчета дохода при торговле на платформе.",
  "comment": "Комментарий",
  "card_market": "CardMarket",
  "profit_potential": "Потенциальная прибыль",
  "calculation_result": "Результат расчета",
  "monthly_sales": "Ежемесячный потенциал продаж",
  "per_month": "Прибыль в месяц",
  "per_year": "Прибыль в год",
  "taking": "С учетом*",
  "plat_fee": "Комиссия платформы",
  "contact_fee": "Комиссия контакта",
  "bank_fee": "Банковская комиссия",
  "question_1": "Что такое калькулятор нетворкинга?",
  "text_1": "Это интерактивный инструмент, который позволяет оценить потенциальный доход от использования нашей платформы. После ввода информации калькулятор покажет вам предполагаемый месячный и годовой доход, а также разовые продажи на один контакт. Это отличный способ оценить потенциал заработка вашей сети контактов и начать использовать нашу платформу для улучшения вашего бизнеса или карьеры.",
  "question_2": "Я смогу заключать только 20 сделок в месяц?",
  "text_2": "Доход в «Калькуляторе нетворкинга» рассчитывается на основе введенных пользователем данных о стоимости доступа к контактам на трех уровнях доверия. Калькулятор учитывает общую сумму цен на контакты и оценивает потенциальную прибыль за год, месяц и разовую продажу каждого контакта. Учитывая, что пользователь может знакомить до 20 человек в день, калькулятор определяет потенциал продаж для каждого уровня доступа, разделив его на 50 %",
  "question_3": "Какие данные нужно ввести в калькулятор?",
  "text_3": "Чтобы воспользоваться калькулятором, вам необходимо ввести количество сделок, которые вы можете совершить за месяц (в среднем не более 20), и среднюю желаемую цену для каждого уровня доступа (A, B, C) на нашей платформе. На основе этих данных калькулятор автоматически рассчитает ваш потенциальный заработок, учитывая возможность продажи каждого контакта и количество продаж в месяц.",
  "question_4": "В чем разница между уровнями доступа (A, B, C)?",
  "text_4": "Уровень А — высокий уровень доверия к человеку. Вы поддерживаете с ним близкие отношения и постоянно общаетесь. Уровень B — средний уровень доверия. Вы достаточно регулярно общаетесь с собеседником и поддерживаете с ним связь. Уровень C — минимальный уровень доверия. Вы знакомы с этим человеком, но не часто с ним общаетесь.",
  "occupation": "Род деятельности",
  "can_help": "Могу помочь с...",
  "looking": "Ищу",
  "can_introduce": "Могу познакомить с...",
  "profile_info_text": "Укажите теги, которые лучше всего описывают вас. Это сделает вас более узнаваемым в общем поиске.",
  "update_profile": "Вы успешно обновили профиль",
  "upload_new": "Загрузить",
  "edit_size": "Редактировать",
  "remove": "Удалить",
  "account_info": "Информация об учетной записи",
  "mobile": "Номер мобильного телефона",
  "change": "Изменить",
  "not_confirmed": "Не подтверждено",
  "confirmed": "Подтвержденный",
  "security_level": "Уровень безопасности",
  "good": "Хороший",
  "average": "Средний",
  "delete_profile": "Удалить профиль",
  "delete_btn": "Удалить",
  "delete_prof_msg": "Вы уверены, что хотите удалить свою учетную запись?",
  "delete_prof": "Это действие нельзя отменить, и все ваши данные будут безвозвратно утеряны.",
  "deleted_msg": "Ваш профиль успешно удален.",
  "add_password": "Добавить пароль",
  "pass_modal_text": "На смс-код можно установить пароль, который будет требоваться при входе с нового устройства.",
  "repeat_password": "Повторите пароль",
  "pin_mail_subtitle": "На этот адрес электронной почты был отправлен код подтверждения.",
  "email_confirmed": "Электронная почта успешно добавлена",
  "pass_added": "Пароль добавлен",
  "pass_msg": "Ваша учетная запись теперь еще безопаснее 💪🏻",
  "email_subtitle": "Чтобы восстановить пароль, если вы его забудете, добавьте свой адрес электронной почты",
  "confirm_email": "Подтвердите ваш адрес электронной почты",
  "confirm_email_text": "Пожалуйста, подтвердите свою электронную почту, чтобы верифицировать свою учетную запись и получить  доступ ко всем функциям платформы.",
  "glad_to_see": "Мы рады видеть вас. Давайте вместе улучшим ваш нетворкинг!",
  "deals_month": "Сделок/месяц",
  "per_month_per": "/месяц.",
  "get_start": "Начните работу с CardBook здесь",
  "steps": "3 шага вперед",
  "deals": "Сделок",
  "avg_trans_time": "Ср. время. транз ",
  "rating": "Рейтинг",
  "access": "Доступ",
  "show_more": "Показать больше",
  "what_are_they_and_how_do_they_differ": "Уровни доступа: что это такое и чем они отличаются? ",
  "has_access": "Имеет доступ",
  "change_email": "Изменение электронной почты",
  "change_email_subtitle": "Вы можете менять адрес электронной почты не чаще двух раз в 30 дней.",
  "change_phone_subtitle": "Вы можете менять номер телефона не чаще двух раз в 30 дней.",
  "new_email": "Новый E-mail",
  "new_phone": "Номер телефона",
  "current_password": "Введите текущий пароль",
  "change_email_hint": "Пароль для входа в аккаунт",
  "pin_mail_change": "Мы отправили код на указанный вами адрес электронной почты.",
  "email_success": "Электронная почта изменена на",
  "change_phone": "Изменить номер телефона",
  "change_pass": "Изменить пароль",
  "new_pass": "Новый пароль",
  "cancel": "Отмена",
  "change_pass_confirm": "Подтвердить смену пароля",
  "change_pass_subtitle": "Если вы хотите установить новый пароль, нажмите «Изменить пароль».",
  "pass_success": "Ваш пароль был успешно изменен",
  "success": "Успех!",
  "phone_success": "Ваш номер мобильного телефона обновлен.",
  "error_correct": "В одном или нескольких полях есть ошибка. ",
  "contact_deleted": "Контакт удален",
  "reset_success": "Ваш пароль был успешно сброшен.",
  "click_to_download_your_first_business_card": "Нажмите, чтобы загрузить свою первую визитку",
  "card_market_box_title": "Этот раздел будет доступен совсем скоро, ",
  "card_market_box_subtitle": "а пока вы можете узнать свой потенциальный заработок",
  "add_new_cards": "Добавить новую визитку",
  "add_new_cards_text": "Введите данные человека, о котором вы хотите добавить информацию, чтобы проверить совпадения на платформе",
  "referral": "Реферальная система",
  "referral_welcome": "Наша реферальная система в настоящее время предназначена исключительно для владельцев сообществ.",
  "apply_now": "Подать заявку сейчас!",
  "community_owner": "Если вы являетесь владельцем сообщества, вы можете подать заявку на проверку.",
  "ref_approve": "После одобрения вы получите доступ к реферальной программе, а ваша учетная запись будет подтверждена галочкой.",
  "verification": "Проверка",
  "verif_desc": "Проверка гарантирует, что личный профиль действительно принадлежит владельцу сообщества. ",
  "verif_text": "Для проверки убедитесь, что",
  "link_mob": "Привязанный номер мобильного телефона",
  "link_mob_required": "Чтобы подать заявку, привяжите номер мобильного телефона.",
  "link_mob_go_settings": "Перейти в настройки",
  "profile_photo": "Набор фотографий профиля",
  "basic_info": "Основная информация заполнена",
  "community": "В сообществе 100 участников.",
  "ref_form_title": "Если вы владелец сообщества, пожалуйста, заполните форму и расскажите немного о себе и своей компании.",
  "ref_form_subtitle": "После получения заявки наш менеджер свяжется с вами напрямую.",
  "community_name": "Название вашего сообщества",
  "community_link": "Ссылка на сообщество",
  "members_title": "Количество участников в вашем сообществе и местоположение (международное/название страны с наибольшим количеством участников)",
  "description_title": "Кратко опишите, для кого предназначено ваше сообщество",
  "value_title": "Какова его ценность",
  "activities_title": "Какие мероприятия вы организуете (зумы, оффлайн встречи)",
  "your_reply": "Ваш ответ",
  "last_login": "Время последнего входа",
  "ref_thanks": "Спасибо за вашу заявку!",
  "receive_approve": "Мы получили ее и находимся в процессе проверки вашего статуса владельца сообщества. Пожалуйста, ожидайте обновлений в ближайшее время.",
  "close": "Закрыть",
  "referral_form_confirmed": "Ваша заявка отправлена. Мы свяжемся с вами в ближайшее время. С наилучшими пожеланиями!",
  "link_invite": "Ссылка-приглашение",
  "ref_percent": "Получайте {percent}% от всех транзакций, совершаемых вашими рефералами!",
  "invites": "Мои приглашения",
  "total_invites": "Всего приглашений",
  "potential_earn": "Потенциальный заработок",
  "transaction_qty": "Совершили сделку",
  "balance": "Общий баланс",
  "dynamic_earn": "Динамика заработка",
  "period": "последние 12 месяцев",
  "invite": "Пригласить",
  "copied": "Скопировано",
  "restore": "Восстановить",
  "add_photo_warning": "Если вы хотите добавить новый контакт в свой цифровой банк, вам необходимо добавить фотографию.",
  "connects_qty": "пользователи могут связать вас",
  "query_no_results": "Ваш запрос не дал результатов",
  "digital_bank_search": "Поиск цифрового банка",
  "level": "Уровень",
  "arts_and_entertainment": "Искусство и развлечения",
  "diversified_holding": "Диверсифицированный холдинг",
  "education": "Образование",
  "electronic_commerce": "Электронная коммерция",
  "fashion_and_beauty_industry": "Индустрия моды и красоты",
  "finance_banks_insurance_investments_": "Финансы (банки/страхование/инвестиции)",
  "hotel_and_restaurant_business": "Гостиничный и ресторанный бизнес",
  "industry": "Промышленность",
  "it_internet_digital": "ИТ, Интернет, Цифра",
  "marketing": "Маркетинг",
  "media_and_communications": "СМИ, коммуникации и средства массовой информации",
  "medicine": "Медицина",
  "private_equility_and_venture_investments": "Частный капитал и венчурные инвестиции",
  "real_estate_and_development": "Недвижимость и девелопмент",
  "retail_trade": "Розничная торговля",
  "state_and_municipal_administration": "Государственное и муниципальное управление",
  "tourism_and_travel": "Туризм и путешествия",
  "construction": "Строительство ",
  "finance": "Финансы ",
  "information_technology": "Информационные технологии",
  "jurisprudence": "Юриспруденция",
  "marketing_advertising_pr": "Маркетинг, реклама, PR ",
  "personnel_management": "Кадровый менеджмент",
  "procurement": "Приобретение",
  "project_management": "Управление проектом",
  "sales": "Продажи",
  "strategy": "Стратегия",
  "transport_logistics": "Транспортная логистика",
  "product_development": "Разработка продукта",
  "top_management": "Высшее руководство",
  "operational_efficiency": "Операционная эффективность",
  "design": "Дизайн ",
  "increasing_labor_productivity": "Повышение производительности труда",
  "engineering_activities": "Инженерная деятельность",
  "b2b_marketing": "B2B-маркетинг",
  "b2c_marketing": "B2C-маркетинг",
  "digital_marketing": "Цифровой маркетинг",
  "smm": "СММ",
  "analysis_of_the_competitive_environment": "Анализ конкурентной среды",
  "brand_management": "Управление торговой маркой",
  "market_research": "Исследования рынка",
  "merchandising": "Мерчендайзинг",
  "organisation_of_pr_campaigns": "Организация PR-кампаний",
  "marketing_strategy_development": "Разработка маркетинговой стратегии",
  "pr_strategy_development": "разработка PR-стратегии",
  "advertising_campaing": "Рекламные кампании",
  "market_segmentation": "Сегментация рынка",
  "trade_marketing": "Торговый маркетинг",
  "audit": "Аудит",
  "financial_statements": "Финансовые отчеты",
  "accounting": "Бухгалтерский учет",
  "investments": "Вложения",
  "currency_operations": "Валютные операции",
  "treasury_department": "Казначейство",
  "taxes": "Налоги",
  "tax_reporting": "Налоговая отчетность",
  "tax_optimization": "Налоговая оптимизация",
  "assessment_of_investment_projects": "Оценка инвестиционных проектов",
  "risk_management": "Управление рисками",
  "investment_management": "Управление инвестициями",
  "management_accounting": "Управленческий учет",
  "financial_modeling": "Финансовое моделирование",
  "financial_planning": "Финансовое планирование",
  "the_financial_analysis": "Финансовый анализ",
  "financial_management": "Финансовый менеджмент",
  "fea_procurement_of_services": "ВЭД",
  "purchase_for_investment_projects": "Покупка для инвестиционных проектов",
  "supplier_classification_and_segmentation": "Классификация и сегментация поставщиков",
  "procurement_optimization": "Оптимизация закупок",
  "procurement_planning": "Планирование закупок",
  "supply_development": "Развитие поставок",
  "materials_management": "Управление материалами",
  "purchasing_management": "Управление закупками",
  "inventory_management": "Управление запасами",
  "category_management": "Управление категориями",
  "supplier_performance_management": "Управление эффективностью поставщиков",
  "big_data": "Большие данные",
  "blockchain": "Блокчейн",
  "data_mining": "Сбор данных",
  "administration": "Администрация",
  "implementation": "Выполнение",
  "architecture": "Архитектура",
  "external_audit_of_information_systems": "Внешний аудит информационных систем",
  "infrastructure": "Инфраструктура",
  "programming": "Программирование",
  "artificial_intelligence": "Искусственный интеллект",
  "computer_security": "Компьютерная безопасность",
  "software_development": "Разработка программного обеспечения",
  "technical_support": "Техническая поддержка",
  "b2b_sales": "B2B-продажи",
  "b2c_sales": "B2C-продажи",
  "b2g_sales": "B2G-продажи",
  "sales_analysis": "Анализ продаж",
  "commercial_management": "Коммерческий менеджмент",
  "sales_support": "Поддержка продаж",
  "after_sales_post": "Пост после продажи",
  "sales_development": "Отдел продаж",
  "development_of_a_sales_strategy": "Разработка стратегии продаж",
  "telephone_sales": "Телефонные продажи",
  "sales_management": "Управление продажами",
  "civil_engineering": "Гражданское строительство",
  "road_construction": "Дорожное строительство",
  "commercial_real_estate": "Коммерческая недвижимость",
  "construction_control": "Строительный контроль",
  "construction_mechanization": "Строительная механизация",
  "property_valuation": "Оценка недвижимости",
  "industrial_real_estate": "Промышленная недвижимость",
  "construction_support": "Поддержка строительства",
  "property_management": "Управление недвижимостью",
  "construction_management": "Управление строительством",
  "developer_functions": "Функции разработчика",
  "internal_logistics": "Внутренняя логистика",
  "supply_control": "Контроль поставок",
  "logistics_management": "Управление логистикой",
  "optimization_of_logistics_processes": "Оптимизация логистических процессов",
  "demand_planning": "Планирование спроса",
  "supply_chain_planning": "Планирование цепочки поставок",
  "production_planning": "Планирование производства",
  "distribution_logistics": "Дистрибьюторская логистика",
  "warehouse_logistics": "Складская логистика",
  "transportation_management": "Управление транспортом",
  "supply_chain_management": "Управление цепочками поставок",
  "staff_adaptation": "Адаптация персонала",
  "hr_records_management": "Ведение кадрового делопроизводства",
  "compensation_and_benefits": "Компенсации и льготы",
  "motivation": "Мотивация",
  "personnel_assessment": "Оценка персонала",
  "professional_competencies": "Профессиональные компетенции",
  "development": "Разработка",
  "recruitment": "Набор персонала",
  "development_of_policies_and_procedures": "Разработка политик и процедур",
  "staff_reduction": "Сокращение персонала",
  "talent_management": "Управление талантами",
  "managerial_competencies": "Управленческие компетенции",
  "copyright": "Авторские права",
  "administrative_law": "Административное право",
  "shareholding_law": "Акционерное право",
  "audit_of_legal_documents": "Аудит юридических документов",
  "civil_law": "Гражданский закон",
  "corporate_governance": "Корпоративное управление",
  "international_law": "Международное право",
  "tax_law": "Закон о налоге",
  "development_of_legal_documents": "Разработка юридических документов",
  "litigation": "Судебные разбирательства",
  "customs_law": "Таможенное право",
  "labor_law": "Трудовое право",
  "economic_law": "Экономический закон",
  "private_right": "Частное право",
  "business_analysis": "Бизнес-анализ",
  "business_process_optimization": "Оптимизация бизнес-процессов",
  "project_planning": "Планирование проекта",
  "project_documentation": "Проектная документация",
  "development_of_technical_specifications": "Разработка технического задания",
  "digital_strategy": "Цифровая стратегия",
  "corporate_strategy": "Корпоративная стратегия",
  "marketing_strategy": "Маркетинговая стратегия",
  "modeling": "Моделирование",
  "strategy_development": "Разработка стратегии",
  "implementation_of_the_strategy": "Реализация стратегии",
  "strategic_analysis": "Стратегический анализ",
  "strategic_consulting": "Стратегический консалтинг",
  "strategic_marketing": "Стратегический маркетинг",
  "strategic_management": "Стратегический менеджмент",
  "strategic_planning": "Стратегическое планирование",
  "positioning_strategy": "Стратегия позиционирования ",
  "sales_strategy": "Стратегия продаж",
  "promotion_strategy": "Стратегия продвижения",
  "development_strategy": "Стратегия развития",
  "strategy_management": "Стратегическое управление",
  "b2b": "B2B",
  "b2c": "B2C",
  "b2g": "B2G",
  "c2c": "C2C",
  "fintech": "Финтех",
  "business_modeling": "Бизнес-моделирование",
  "conversion_boost": "Повышение конверсии",
  "e_learning": "Электронное обучение",
  "electronic_banking": "Электронный банкинг",
  "email_marketing": "Рекламная рассылка",
  "electronic_information_exchange": "Электронный обмен информацией",
  "analysis_of_consumer_preferences": "Анализ потребительских предпочтений",
  "testing": "Тестирование",
  "export_sales ": "Экспортные продажи",
  "construction_development": "Развитие строительства",
  "logistics_business_modeling": "Логистическое бизнес-моделирование",
  "hr_strategy": "HR-стратегия",
  "corporate_law": "Корпоративное право",
  "criminal_law": "Уголовное право",
  "analytics": "Аналитика",
  "road_map": "Дорожная карта",
  "usability": "Удобство использования",
  "use_case_analysis": "Анализ вариантов использования",
  "bringing_the_product_to_market": "Вывод продукта на рынок",
  "product_interface_design": "Дизайн интерфейса",
  "launch_of_new_products": "Запуск новых продуктов",
  "needs_research": "Требует исследования",
  "industrial_design": "Индустриальный дизайн",
  "new_product_development": "Разработка нового продукта",
  "development_of_a_product_development_strategy": "Разработка стратегии развития продукта",
  "product_management": "Управление продуктом",
  "economic_analysis": "Экономический анализ",
  "crisis_management": "Антикризисное управление",
  "corporate_leadership": "Корпоративное лидерство",
  "organisation_management": "Управление организацией",
  "operations_management": "Управление операциями",
  "organizational_design": "Организационный дизайн",
  "process_and_project_management": "Управление процессами и проектами",
  "top_risk_management": "Управление рисками",
  "top_strategic_management": "Стратегический менеджмент",
  "business_process_management": "управление бизнес-процессами",
  "improving_the_quality_of_the_product_service": "Улучшение качества продукта/услуги",
  "cost_reduction": "Снижение цены",
  "improvement_of_business_processes": "Улучшение бизнес-процессов",
  "3d_visualization": "3D-визуализация",
  "layout": "Макет",
  "exhibition_stage_design": "Выставочный/сценический дизайн",
  "vjing_vj": "Виджеинг (ВиДжей)",
  "print_design": "Полиграфический дизайн",
  "presentation_design": "Дизайн презентации",
  "illustration": "Иллюстрация",
  "interface_design": "Дизайн интерфейса",
  "infographics": "Инфографика",
  "motion_design": "Моушн-дизайн",
  "ux_ui_design": "UX/UI дизайн",
  "identity_development": "Разработка айдентики",
  "character_development": "Развитие персонажа",
  "creating_a_brand_book": "Создание брендбука",
  "fea": "ВЭД",
  "procurement_of_services": "Закупка услуг",
  "how_add_card": "Как добавить визитку в Digital Bank за 3 клика?",
  "levels_mean": "Что означают уровни A, B, C?",
  "how_potential_income": "Как работает калькулятор потенциального дохода?",
  "how_referral_system": "Как подать заявку на использование реферальной системы?",
  "answers_community": "Ответы на эти и другие вопросы доступны в нашем боте и комьюнити",
  "join_community": "Хочу в комьюнити",
  "get_help": "Получить помощь",
  "your_help": "Ваш Центр Помощи",
  "help_text": "Вопросы, проблемы, идеи — мы готовы помочь и вместе двигаться вперед 👇🏻",
  "complete_profile_occu": "Заполнить профиль",
  "where_begin": " С чего начать",
  "afghanistan": "Афганистан",
  "aland_islands": "Аландские острова",
  "albania": "Албания",
  "algeria": "Алжир",
  "american_samoa": "Американское Самоа",
  "andorra": "Андорра",
  "angola": "Ангола",
  "anguilla": "Ангилья",
  "antarctica": "Антарктика",
  "antigua_and_barbuda": "Антигуа и Барбуда",
  "argentina": "Аргентина",
  "armenia": "Армения",
  "aruba": "Аруба",
  "australia": "Австралия",
  "austria": "Австрия",
  "azerbaijan": "Азербайджан",
  "bahamas": "Багамы",
  "bahrain": "Бахрейн",
  "bangladesh": "Бангладеш",
  "barbados": "Барбадос",
  "belarus": "Беларусь",
  "belgium": "Бельгия",
  "belize": "Белиз",
  "benin": "Бенин",
  "bermuda": "Бермуды",
  "bhutan": "Бутан",
  "bolivia_plurinational_state_of": "Боливия, Многонациональное Государство",
  "bosnia_and_herzegovina": "Босния и Герцеговина",
  "botswana": "Ботсвана",
  "brazil": "Бразилия",
  "british_indian_ocean_territory": "Британская территория в Индийском океане",
  "brunei_darussalam": "Бруней-Даруссалам",
  "bulgaria": "Болгария",
  "burkina_faso": "Буркина-Фасо",
  "burundi": "Бурунди",
  "cambodia": "Камбоджа",
  "cameroon": "Камерун",
  "canada": "Канада",
  "cape_verde": "Кабо-Верде",
  "cayman_islands": "Каймановы острова",
  "central_african_republic": "Центральноафриканская Республика",
  "chad": "Чад",
  "chile": "Чили",
  "china": "Китай",
  "christmas_island": "Остров Рождества",
  "cocos_keeling_islands": "Кокосовые (Килинг) острова",
  "colombia": "Колумбия",
  "comoros": "Коморы",
  "congo": "Конго",
  "congo_the_democratic_republic_of_the_congo": "Конго, Демократическая Республика Конго",
  "cook_islands": "Острова Кука",
  "costa_rica": "Коста-Рика",
  "cote_d_ivoire": "Кот-д'Ивуар",
  "croatia": "Хорватия",
  "cuba": "Куба",
  "cyprus": "Кипр",
  "czech_republic": "Чешская Республика",
  "denmark": "Дания",
  "djibouti": "Джибути",
  "dominica": "Доминика",
  "dominican_republic": "Доминиканская Республика",
  "ecuador": "Эквадор",
  "egypt": "Египет",
  "el_salvador": "Сальвадор",
  "equatorial_guinea": "Экваториальная Гвинея",
  "eritrea": "Эритрея",
  "estonia": "Эстония",
  "ethiopia": "Эфиопия",
  "falkland_islands_malvinas_": "Фолклендские острова (Мальвинские)",
  "faroe_islands": "Фарерские острова",
  "fiji": "Фиджи",
  "finland": "Финляндия",
  "france": "Франция",
  "french_guiana": "Французская Гвиана",
  "french_polynesia": "Французская Полинезия",
  "gabon": "Габон",
  "gambia": "Гамбия",
  "georgia": "Грузия",
  "germany": "Германия",
  "ghana": "Гана",
  "gibraltar": "Гибралтар",
  "greece": "Греция",
  "greenland": "Гренландия",
  "grenada": "Гренада",
  "guadeloupe": "Гваделупа",
  "guam": "Гуам",
  "guatemala": "Гватемала",
  "guernsey": "Гернси",
  "guinea": "Гвинея",
  "guinea_bissau": "Гвинея-Бисау",
  "guyana": "Гайана",
  "haiti": "Гаити",
  "holy_see_vatican_city_state_": "Святой Престол (государство Ватикан)",
  "honduras": "Гондурас",
  "hong_kong": "Гонконг",
  "hungary": "Венгрия",
  "iceland": "Исландия",
  "india": "Индия",
  "indonesia": "Индонезия",
  "iran_islamic_republic_of_persian_gulf": "Иран, Исламская Республика Персидского залива",
  "iraq": "Ирак",
  "ireland": "Ирландия",
  "isle_of_man": "Остров Мэн",
  "israel": "Израиль",
  "italy": "Италия",
  "jamaica": "Ямайка",
  "japan": "Япония",
  "jersey": "Джерси",
  "jordan": "Иордания",
  "kazakhstan": "Казахстан",
  "kenya": "Кения",
  "kiribati": "Кирибати",
  "korea_democratic_people_s_republic_of_korea": "Корейская Народно-Демократическая Республика Корея",
  "korea_republic_of_south_korea": "Республика Корея",
  "kuwait": "Кувейт",
  "kyrgyzstan": "Киргизия",
  "laos": "Лаос",
  "latvia": "Латвия",
  "lebanon": "Ливан",
  "lesotho": "Лесото",
  "liberia": "Либерия",
  "libyan_arab_jamahiriya": "Ливийская Арабская Джамахирия",
  "liechtenstein": "Лихтенштейн",
  "lithuania": "Литва",
  "luxembourg": "Люксембург",
  "macao": "Макао",
  "macedonia": "Македония",
  "madagascar": "Мадагаскар",
  "malawi": "Малави",
  "malaysia": "Малайзия",
  "maldives": "Мальдивы",
  "mali": "Мали",
  "malta": "Мальта",
  "marshall_islands": "Маршалловы острова",
  "martinique": "Мартиника",
  "mauritania": "Мавритания",
  "mauritius": "Маврикий",
  "mayotte": "Майотта",
  "mexico": "Мексика",
  "micronesia_federated_states_of_micronesia": "Микронезия, Федеративные Штаты Микронезии",
  "moldova": "Молдова",
  "monaco": "Монако",
  "mongolia": "Монголия",
  "montenegro": "Черногория",
  "montserrat": "Монтсеррат",
  "morocco": "Марокко",
  "mozambique": "Мозамбик",
  "myanmar": "Мьянма",
  "namibia": "Намибия",
  "nauru": "Науру",
  "nepal": "Непал",
  "netherlands": "Нидерланды",
  "netherlands_antilles": "Нидерландские Антильские острова",
  "new_caledonia": "Новая Каледония",
  "new_zealand": "Новая Зеландия",
  "nicaragua": "Никарагуа",
  "niger": "Нигер",
  "nigeria": "Нигерия",
  "niue": "Ниуэ",
  "norfolk_island": "Остров Норфолк",
  "northern_mariana_islands": "Северные Марианские острова",
  "norway": "Норвегия",
  "oman": "Оман",
  "pakistan": "Пакистан",
  "palau": "Палау",
  "palestinian_territory_occupied": "Палестинская территория, оккупированная",
  "panama": "Панама",
  "papua_new_guinea": "Папуа-Новая Гвинея",
  "paraguay": "Парагвай",
  "peru": "Перу",
  "philippines": "Филиппины",
  "pitcairn": "Питкэрн",
  "poland": "Польша",
  "portugal": "Португалия",
  "puerto_rico": "Пуэрто-Рико",
  "qatar": "Катар",
  "romania": "Румыния",
  "russia": "Россия",
  "rwanda": "Руанда",
  "reunion": "Реюньон",
  "saint_barthelemy": "Сен-Бартельми",
  "saint_helena_ascension_and_tristan_da_cunha": "Остров Святой Елены, Вознесения и Тристан-да-Кунья",
  "saint_kitts_and_nevis": "Сент-Китс и Невис",
  "saint_lucia": "Сент-Люсия",
  "saint_martin": "Сент-Мартин",
  "saint_pierre_and_miquelon": "Сен-Пьер и Микелон",
  "saint_vincent_and_the_grenadines": "Сент-Винсент и Гренадины",
  "samoa": "Самоа",
  "san_marino": "Сан-Марино",
  "sao_tome_and_principe": "Сан-Томе и Принсипи",
  "saudi_arabia": "Саудовская Аравия",
  "senegal": "Сенегал",
  "serbia": "Сербия",
  "seychelles": "Сейшельские острова",
  "sierra_leone": "Сьерра-Леоне",
  "singapore": "Сингапур",
  "slovakia": "Словакия",
  "slovenia": "Словения",
  "solomon_islands": "Соломоновы острова",
  "somalia": "Сомали",
  "south_africa": "Южная Африка",
  "south_sudan": "Южный Судан",
  "south_georgia_and_the_south_sandwich_islands": "Южная Джорджия и Южные Сандвичевы острова",
  "spain": "Испания",
  "sri_lanka": "Шри-Ланка",
  "sudan": "Судан",
  "suriname": "Суринам",
  "svalbard_and_jan_mayen": "Шпицберген и Ян-Майен",
  "swaziland": "Свазиленд",
  "sweden": "Швеция",
  "switzerland": "Швейцария",
  "syrian_arab_republic": "Сирийская Арабская Республика",
  "taiwan": "Тайвань",
  "tajikistan": "Таджикистан",
  "tanzania_united_republic_of_tanzania": "Танзания, Объединенная Республика Танзания",
  "thailand": "Таиланд",
  "timor_leste": "Восточный Тимор",
  "togo": "Того",
  "tokelau": "Токелау",
  "tonga": "Тонга",
  "trinidad_and_tobago": "Тринидад и Тобаго",
  "tunisia": "Тунис",
  "turkey": "Турция",
  "turkmenistan": "Туркменистан",
  "turks_and_caicos_islands": "Теркс и Кайкос",
  "tuvalu": "Тувалу",
  "uganda": "Уганда",
  "ukraine": "Украина",
  "united_arab_emirates": "Объединенные Арабские Эмираты",
  "united_kingdom": "Великобритания",
  "united_states": "Соединенные Штаты",
  "uruguay": "Уругвай",
  "uzbekistan": "Узбекистан",
  "vanuatu": "Вануату",
  "venezuela_bolivarian_republic_of_venezuela": "Венесуэла, Боливарианская Республика Венесуэла",
  "vietnam": "Вьетнам",
  "virgin_islands_british": "Виргинские острова, Британские",
  "virgin_islands_u_s_": "Виргинские острова, США",
  "wallis_and_futuna": "Уоллис и Футуна",
  "yemen": "Йемен",
  "zambia": "Замбия",
  "zimbabwe": "Зимбабве",
  "okay": "Окей",
  "profile": "Профиль",
  "avg_price": "Средняя цена",
  "delete_from_bank": "Удалить из Digital Bank",
  "levels_on_platform": "Уровни доступа  на платформе",
  "text_banner": "Узнайте, что это и как правильно устанавливать их для своих контактов, нажав на этот баннер",
  "levels": "Уровень доступа ",
  "on_platform": "на платформе",
  "text_banner_help": "Ищите ответы и связывайтесь с нами  в разделе поддержки. Ваш комфорт - наш приоритет.",
  "banner_help": "Нужна помощь?",
  "upload_card": "Загрузите свою первую визитку здесь",
  "displayed_here": "Здесь будут отображаться ваши контакты",
  "welcome_digital": "Добро пожаловать в Digital Bank",
  "text_card_banner": "Ваш персональный маркет визиток находится в разработке. Используйте калькулятор, чтобы узнать свой потенциальный доход.",
  "level_plat": "Уровни доступа на платформе",
  "text_abc_banner": "Узнайте, что это и как правильно устанавливать их для своих контактов, нажав на этот баннер",
  "text_digital_banner": "Ваш личный цифровой банк визитных карточек, где вы можете хранить и добавлять самые ценные контакты",
  "contacts_s": "Контактов",
  "invite_header": "Пригласи в CardBook",
  "invite_text": "Каждый, кто зарегистрируется, станет частью вашего DigitalBank.",
  "link_one": "Ссылка",
  "contact": "Контакт",
  "active_link": "Ссылка активна 48 часов",
  "update_link": "Обновить ссылку",
  "visible": "Видно только вам",
  "text_pop": "Используется для удобства и быстрого поиска",
  "add_to_my_bank": "Добавить в мой DigitalBank",
  "additional_account": "Дополнительная защита аккаунта",
  "to_login": "Чтобы войти в систему, изменить настройки безопасности",
  "necessary_to_reset": "Это необходимо для сброса пароля, активации аккаунта и получения уведомлений о транзакциях.",
  "comment_modal": "A - близкие контакты, B - регулярные, C - знакомые  ",
  "click_connec": "Связь в один клик",
  "connec_text": "Добавьте ссылку на свою соцсеть или мессенджер, чтобы оставаться на связи вне платформы.",
  "your_link": "Ваша ссылка",
  "no_link": "У этого пользователя нет указанных контактов для связи.",
  "text_contact": "Пользователь оставил удобный для себя способ связи с ним.",
  "afar": "Афарский",
  "abkhazian": "Абхазский",
  "avestan": "Авестийский",
  "afrikaans": "Австралийский",
  "akan": "Акан",
  "amharic": "Амхарский",
  "aragonese": "Арагонский",
  "arabic": "Арабский",
  "assamese": "Ассамский",
  "avaric": "Аварский",
  "aymara": "Аймара",
  "azerbaijani": "Азербайджанский",
  "bashkir": "Башкирский",
  "belarusian": "Белорусский",
  "bulgarian": "Болгарский",
  "bihari_languages": "Бихарские языки",
  "bislama": "Бислама",
  "bambara": "Бамбара",
  "bengali": "Бенгальский",
  "tibetan": "Тибетский",
  "breton": "Бретонский",
  "bosnian": "Боснийский",
  "catalan": "Каталанский",
  "chechen": "Чеченский",
  "chamorro": "Чаморро",
  "corsican": "Корсиканский",
  "cree": "Кри",
  "czech": "Чешский",
  "chuvash": "Чувашский",
  "welsh": "Валлийский",
  "danish": "Датский",
  "german": "Немецкий",
  "divehi": "Дивехи",
  "dzongkha": "Дзонг-кха",
  "ewe": "Эве",
  "greek_modern_1453_": "Греческий, современный (1453 г.)",
  "english": "Английский",
  "esperanto": "Эсперанто",
  "spanish": "Испанский",
  "estonian": "Эстонский",
  "basque": "Баскский",
  "persian": "Персидский",
  "fulah": "Фула",
  "finnish": "Финский",
  "fijian": "Фиджи",
  "faroese": "Фарерский",
  "french": "Французский",
  "western_frisian": "Западно-фризский",
  "irish": "Ирландский",
  "gaelic": "Гэльский",
  "galician": "Галисийский",
  "guarani": "Гуарани",
  "gujarati": "Гуджарати",
  "manx": "Мэнкс",
  "hausa": "Хауса",
  "hebrew": "Иврит",
  "hindi": "Хинди",
  "hiri_motu": "Хири моту",
  "croatian": "Хорватский",
  "haitian": "Гаитянский",
  "hungarian": "Венгерский",
  "armenian": "Армянский",
  "herero": "Хереро",
  "indonesian": "Индонезийский",
  "igbo": "Игбо",
  "sichuan_yi": "Сычуань йи",
  "inupiaq": "Инупиак",
  "ido": "Идо",
  "icelandic": "Исландский",
  "italian": "Итальянский",
  "inuktitut": "Инуктитут",
  "japanese": "Японский",
  "javanese": "Яванский",
  "georgian": "Грузинский",
  "kongo": "Конго",
  "kikuyu": "Кикуйю",
  "kuanyama": "Куаньяма",
  "kazakh": "Казахский",
  "greenlandic": "Гренландский",
  "central_khmer": "Центрально-хмерский",
  "kannada": "Каннада",
  "korean": "Корейский",
  "kanuri": "Канури",
  "kashmiri": "Кашмирский",
  "kurdish": "Курдский",
  "komi": "Коми",
  "cornish": "Корниш",
  "kirghiz": "Киргизский",
  "latin": "Латинский",
  "luxembourgish": "Люксембургский",
  "ganda": "Ганда",
  "limburgan": "Лимбургский",
  "lingala": "Лингала",
  "lao": "Лаосский",
  "lithuanian": "Литовский",
  "luba_katanga": "Луба-катанга",
  "latvian": "Латышский",
  "malagasy": "Малагасийский",
  "marshallese": "Маршалльский",
  "maori": "Маори",
  "macedonian": "Македонский",
  "malayalam": "Малаялам",
  "mongolian": "Монгольский",
  "marathi": "Маратхи",
  "malay": "Малайский",
  "maltese": "Мальтийский",
  "burmese": "Бирманский",
  "norwegian_bokm_l": "Норвежский букмол",
  "ndebele_north": "Ндебеле, северный",
  "nepali": "Непальский",
  "ndonga": "Ндонга",
  "dutch": "Голландский",
  "norwegian_nynorsk": "Норвежский нюннорск",
  "norwegian": "Норвежский",
  "south_ndebele": "Южный ндебеле",
  "navajo": "Навахо",
  "chichewa": "Чичева",
  "occitan": "Окситанский",
  "ojibwa": "Оджибва",
  "oromo": "Оромо",
  "oriya": "Ория",
  "ossetian": "Осетинский",
  "panjabi": "Панджаби",
  "pali": "Пали",
  "polish": "Польский",
  "pushto": "Пушту",
  "portuguese": "Португальский",
  "quechua": "Кечуа",
  "romansh": "Романш",
  "rundi": "Рунди",
  "romanian": "Румынский",
  "russian": "Русский",
  "kinyarwanda": "Киньяруанда",
  "sanskrit": "Санскрит",
  "sardinian": "Сардинский",
  "sindhi": "Синдхи",
  "northern_sami": "Северный саамский",
  "sango": "Санго",
  "sinhala": "Сингальский",
  "slovak": "Словацкий",
  "slovenian": "Словенский",
  "samoan": "Самоанский",
  "shona": "Шона",
  "somali": "Сомали",
  "albanian": "Албанский",
  "serbian": "Сербский",
  "swati": "Свати",
  "sotho_southern": "Сото, южный",
  "sundanese": "Сунданский",
  "swedish": "Шведский",
  "swahili": "Суахили",
  "tamil": "Тамильский",
  "telugu": "Телугу",
  "tajik": "Таджикский",
  "thai": "Тайский",
  "tigrinya": "Тигринья",
  "turkmen": "Туркменский",
  "tagalog": "Тагальский",
  "tswana": "Тсвана",
  "tonga_tonga_islands_": "Тонга (острова Тонга)",
  "turkish": "Турецкий",
  "tsonga": "Тсонга",
  "tatar": "Татарский",
  "twi": "Тви",
  "tahitian": "Таитянский",
  "uighur": "Уйгурский",
  "ukrainian": "Украинский",
  "urdu": "Урду",
  "uzbek": "Узбекский",
  "venda": "Венда",
  "vietnamese": "Вьетнамский",
  "volap_k": "Волапюк",
  "walloon": "Валлонский",
  "wolof": "Волоф",
  "xhosa": "Коса",
  "yiddish": "Идиш",
  "yoruba": "Йоруба",
  "zhuang": "Чжуанский",
  "chinese": "Китайский",
  "zulu": "Зулу",
  "contact_mod": "Связаться",
  "view_photo": "Посмотреть фото",
  "upload_text": "Вы можете загружать изображения в формате JPG или PNG.",
  "photo_load_error": "Не удалось загрузить изображение. Закройте окно и выберите другой файл.",
  "photo_save_error": "Не удалось сохранить фото. Попробуйте ещё раз.",
  "uploading_photo": "Загрузка фотографии",
  "select_file": "Выберите файл",
  "having_truble": "Если у вас возникли проблемы с загрузкой, попробуйте выбрать фотографию меньшего размера.",
  "choose_photo": "Выберите место для миниатюры. Выбранная вами миниатюра будет использоваться в изображении профиля, личных сообщениях и карточках контактов.",
  "save_changed": "Сохранить изменения",
  "remove_photo": "Удалить фотографию",
  "text_remove": "Вы уверены, что хотите удалить фотографию своего профиля?  Если вы удалите фотографию, ваш профиль будет скрыт из общего поиска на платформе",
  "contacts_digital": "Контактов",
  "comment_modal_info": "Комментарий о том, как вы познакомились, о чем договорились, описание контакта",
  "view_more": "Просмотр",
  "profile_photo_modal": "Фото профиля",
  "card_photo": "Фото карточки",
  "chart_photo": "Фото в чате",
  "code_confirmation": "На эту электронную почту будет отправлен код подтверждения.",
  "level_a": "Уровень A",
  "level_b": "Уровень B",
  "level_c": "Уровень C",
  "community_owner_check": "Владелец сообщества",
  "page_verified": "Страница подтверждена",
  "contact_in_bank": "Этот контакт уже есть в вашем Digital Bank. При необходимости вы можете обновить или изменить информацию о нем.",
  "restore_to_bank": "Этот контакт ранее был в вашем Digital Bank. Вы можете восстановить его, чтобы снова иметь доступ к управлению контактом.",
  "count": "Ваш потенциальный доход здесь",
  "edit_only": "Изменить",
  "select_direction": "Сначала укажите Направление",
  "soon": "Скоро...",
  "A": "Уровень A",
  "B": "Уровень B",
  "C": "Уровень C",
  "selected": "Выбрано",
  "edit_contact_bank": "Вы успешно обновили контакт",
  "platform_language": "Язык платформы",
  "comment_modal_a": "A - Близкие контакты,",
  "comment_modal_b": "B - Регулярные,",
  "comment_modal_c": "C - Знакомые",
  "please_fill_field": "Пожалуйста, заполните все обязательные поля",
  "empty_field": "Пустое поле",
  "all_contacts": "Все контакты",
  "edit_folder": "Ред.",
  "folders":"Папки",
  "create_folder": "Группируйте контакты в папки и легко переключайтесь между ними",
  "my_folders": "Мои папки",
  "create_new_folder": "Создать новую папку",
  "delete_folder": "Удалить папку",
  "subtitle_delete":" Should I delete this folder?",
  "affect_contact": "Удаление папки не повлияет на контакты, которые в ней находятся.",
  "limit_folder": "Достигнут лимит создания папок",
  "new_folder": "Новая папка",
  "folder_name": "Название папки",
  "selected_contacts": "Выбранные контакты",
  "add_contacts": "Добавить контакты",
  "select_contact_show": "Выберите контакты, которые хотите показать в этой папке.",
  "add_folder_name": "Вы должны добавить имя папки, чтобы выбрать контакты",
  "must_add": "Вы должны добавить хотя бы один контакт",
  "no_result": "Ваш запрос не дал результатов",
  "congratulation": "Поздравляем!",
  "folder_success": "Папка успешно создана",
  "view_original_language": "Показать на языке оригинала",
  "view_original": "Показать оригинал",
  "show_translation": "Показать перевод",
  "language_settings": "Настройки языка",
  "check_spam": "Проверьте папку «Спам», если код не пришел.",
  "card_not_a_connection": "Это карточка другого пользователя, а не человек, с которым можно установить связь напрямую. Получите к ней доступ на рынке карточек, чтобы добавить её в свой Digital Bank."
}
